import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
        <App />
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);
reportWebVitals();
